import script from "./FormGeneralComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./FormGeneralComponent.vue?vue&type=script&setup=true&lang=js"

import "./FormGeneralComponent.vue?vue&type=style&index=0&id=c7771dbc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c7771dbc"]])

export default __exports__